import { useState } from "react";

const STORAGE_KEY_ALL = "@claro-lp/agente";
const STORAGE_KEY_1 = "@claro-lp/agente-id";
const STORAGE_KEY_2 = "@claro-lp/agente-usuario-id";

const getInitialAgenteData = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_ALL);
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        matricula: typeof parsed?.matricula === "string" ? parsed.matricula : "",
        agenteUsuarioId:
          typeof parsed?.agenteUsuarioId === "string" ? parsed.agenteUsuarioId : "",
        nome: typeof parsed?.nome === "string" ? parsed.nome : "",
      };
    }

    const matricula = localStorage.getItem(STORAGE_KEY_1) || "";
    const agenteUsuarioId = localStorage.getItem(STORAGE_KEY_2) || "";

    const migrated = { matricula, agenteUsuarioId };
    localStorage.setItem(STORAGE_KEY_ALL, JSON.stringify(migrated));
    localStorage.removeItem(STORAGE_KEY_1);
    localStorage.removeItem(STORAGE_KEY_2);

    return migrated;
  } catch {
    return { matricula: "", agenteUsuarioId: "" };
  }
};

export function useAgenteId() {
  const [agenteData, setAgentedata] = useState(getInitialAgenteData);

  const logoutAgente = () => {
    try {
      localStorage.removeItem(STORAGE_KEY_ALL);
      localStorage.removeItem(STORAGE_KEY_1);
      localStorage.removeItem(STORAGE_KEY_2);
    } catch {}
    setAgentedata({ matricula: "", agenteUsuarioId: "" });
  };

  const setAgente = (matricula, agenteUsuarioId) => {
    const next = {
      matricula: matricula || "",
      agenteUsuarioId: agenteUsuarioId || "",
    };

    try {
      localStorage.setItem(STORAGE_KEY_ALL, JSON.stringify(next));

      localStorage.removeItem(STORAGE_KEY_1);
      localStorage.removeItem(STORAGE_KEY_2);
    } catch {}

    setAgentedata(next);
  };

  return {
    agenteData,
    hasAgente: Boolean(agenteData.agenteUsuarioId),
    logoutAgente,
    setAgente,
  };
}
